import { getRequest, postRequest, getcontractIdNumber } from './api'
import { API_URL_WORKORDER } from '../constants/index'

export async function getMyWorkOrders(createdByUserID, size = 10, index = 0, contractId = null) {
  const url = new URL(`${API_URL_WORKORDER}workOrder/get-my-workorders`)
  const searchParams = new URLSearchParams()
  searchParams.append('createdByUserID', createdByUserID)
  searchParams.append('size', size)
  searchParams.append('index', index)
  searchParams.append('orderByValues', 'CreatedDate DESC')
  if (contractId) {
    searchParams.append('contractId', contractId)
  }
  url.search = searchParams.toString()
  return getRequest(url.toString())
}

export async function checkAssetIsUsing(inventoryID, contractID, workOrderID) {
  return getRequest(
    `workOrder/get-check-asset-is-using/${inventoryID || '%20'}/${contractID ||
      '%20'}/${workOrderID || '%20'}`,
  )
}

export async function listByMainInventoryID(mainInventoryID) {
  return getRequest(`workOrder/getbymaininventory?mainInventoryID=${mainInventoryID}`)
}

export async function getWorkOrders2(
  size,
  index,
  containsValues,
  orderByValues,
  completedDate,
  orderNumber,
  workOrderStatus,
  mainInventoryNumber,
  inventoryNumber,
  workOrderType,
  areaID,
  locationID,
  address,
  callerName,
  trackingNumber,
  partNumbers,
  technicianNames,
  barcode,
  priority,
  isTechnicianNoteExist,
  proposalBudgetStatus,
  inventoryClassID,
) {
  const url = new URL(`${API_URL_WORKORDER}workOrder/get-list2`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  searchParams.append('size', parseInt(size, 10) || 15)
  searchParams.append('index', parseInt(index, 10) || 0)

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  if (completedDate !== null && completedDate !== undefined) {
    searchParams.append('completedDate', completedDate)
  }

  if (workOrderStatus !== null && workOrderStatus !== undefined && workOrderStatus !== '') {
    searchParams.append('workOrderStatus', workOrderStatus)
  }

  if (orderNumber !== null && orderNumber !== undefined) {
    searchParams.append('orderNumber', orderNumber)
  }

  if (address !== null && address !== undefined) {
    searchParams.append('address', address)
  }

  if (areaID !== null && areaID !== undefined) {
    searchParams.append('areaID', areaID)
  }

  if (locationID !== null && locationID !== undefined) {
    searchParams.append('locationID', locationID)
  }

  if (workOrderType !== null && workOrderType !== undefined && workOrderType !== '') {
    searchParams.append('workOrderType', workOrderType)
  }

  if (inventoryNumber !== null && inventoryNumber !== undefined) {
    searchParams.append('inventoryNumber', inventoryNumber)
  }

  if (callerName !== null && callerName !== undefined) {
    searchParams.append('callerName', callerName)
  }

  if (trackingNumber !== null && trackingNumber !== undefined) {
    searchParams.append('trackingNumber', trackingNumber)
  }

  if (partNumbers !== null && partNumbers !== undefined) {
    searchParams.append('partNumbers', partNumbers)
  }

  if (technicianNames !== null && technicianNames !== undefined) {
    searchParams.append('technicianNames', technicianNames)
  }

  if (barcode !== null && barcode !== undefined) {
    searchParams.append('barcode', barcode)
  }

  if (priority !== null && priority !== undefined) {
    searchParams.append('priority', priority)
  }

  if (isTechnicianNoteExist !== null && isTechnicianNoteExist !== undefined) {
    searchParams.append('isTechnicianNoteExist', isTechnicianNoteExist)
  }

  if (proposalBudgetStatus !== null && proposalBudgetStatus !== undefined) {
    searchParams.append('proposalBudgetStatus', proposalBudgetStatus)
  }

  if (mainInventoryNumber !== null && mainInventoryNumber !== undefined) {
    searchParams.append('mainInventoryNumber', mainInventoryNumber)
  }

  if (inventoryClassID !== null && inventoryClassID !== undefined) {
    searchParams.append('inventoryClassID', inventoryClassID)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function getWorkOrdersForInvoice2(
  size,
  index,
  containsValues,
  orderByValues,
  startDate,
  endDate,
  workOrderType,
  inventoryClassID,
  invoiceID = null,
  workOrderStatus = null,
) {
  const url = new URL(`${API_URL_WORKORDER}workOrder/get-list-for-invoice2`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  searchParams.append('size', parseInt(size, 10) || 15)
  searchParams.append('index', parseInt(index, 10) || 0)

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  if (startDate !== null && startDate !== undefined) {
    searchParams.append('startDate', startDate)
  }

  if (endDate !== null && endDate !== undefined) {
    searchParams.append('endDate', endDate)
  }

  if (workOrderType !== null && workOrderType !== undefined && workOrderType !== '') {
    searchParams.append('workOrderType', workOrderType)
  }

  if (inventoryClassID !== null && inventoryClassID !== undefined) {
    searchParams.append('inventoryClassID', inventoryClassID)
  }

  if (invoiceID !== null && invoiceID !== undefined) {
    searchParams.append('invoiceID', invoiceID)
  }

  if (workOrderStatus !== null && workOrderStatus !== undefined && workOrderStatus !== '') {
    searchParams.append('workOrderStatus', workOrderStatus)
  }

  // Cache-buster: this list is re-fetched immediately after adding/removing a
  // work order. Without it the browser can serve the stale (pre-add) cached
  // response, so a just-added work order does not appear until a later refetch.
  searchParams.append('_ts', Date.now())

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function getWorkOrdersForInvoice2Item(
  size,
  index,
  containsValues,
  orderByValues,
  startDate,
  endDate,
  workOrderType,
  inventoryClassID,
  workOrderStatus = null,
  invoice2ItemID = null,
) {
  const url = new URL(`${API_URL_WORKORDER}workOrder/get-list-for-invoice2`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  searchParams.append('size', parseInt(size, 10) || 15)
  searchParams.append('index', parseInt(index, 10) || 0)

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  if (startDate !== null && startDate !== undefined) {
    searchParams.append('startDate', startDate)
  }

  if (endDate !== null && endDate !== undefined) {
    searchParams.append('endDate', endDate)
  }

  if (workOrderType !== null && workOrderType !== undefined && workOrderType !== '') {
    searchParams.append('workOrderType', workOrderType)
  }

  if (inventoryClassID !== null && inventoryClassID !== undefined) {
    searchParams.append('inventoryClassID', inventoryClassID)
  }

  if (invoice2ItemID !== null && invoice2ItemID !== undefined) {
    searchParams.append('invoice2ItemID', invoice2ItemID)
  }

  if (workOrderStatus !== null && workOrderStatus !== undefined && workOrderStatus !== '') {
    searchParams.append('workOrderStatus', workOrderStatus)
  }

  // Cache-buster: same reason as getWorkOrdersForInvoice2 - this list is
  // re-fetched right after attaching a work order to a manual invoice item.
  searchParams.append('_ts', Date.now())

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`workOrder/edit/${id}`)
}
export async function nextControl(contractId, startDate, endDate) {
  return getRequest(`workOrder/get-next-control-date/${contractId}/${startDate}/${endDate}`)
}
export async function nextControlV2(contractId, startDate, endDate, includeMissedPms) {
  return getRequest(
    `workOrder/get-next-control-date-v2/${contractId}/${startDate}/${endDate}/${includeMissedPms}`,
  )
}
export async function get(id) {
  return getRequest(`workOrder/get-workorder/${id}`)
}
export async function getAppointmenDate(id) {
  return getRequest(`workOrder/get-appointment-date/${id}`)
}
export async function defaults(id) {
  return getRequest(`workOrder/defaults/${id}`)
}

export async function save(values) {
  return postRequest(`workOrder/save`, values)
}

export async function updateWorkOrderStatus(workOrderId, status) {
  return postRequest(`workOrder/update-status?workOrderId=${workOrderId}&status=${status}`, {
    values: {},
  })
}

export async function createWorkOrderByProposal(proposalID, withDataFromProposal) {
  console.log('createWorkOrderByProposal proposalID', proposalID)
  return postRequest(
    `workOrder/create-from-proposal/${proposalID}?withDataFromProposal=${withDataFromProposal ||
      false}`,
    { values: {} },
  )
}

export async function logAssetChange(values) {
  return postRequest(`workOrder/log-asset-from-web`, values)
}

export async function saveAsset(values) {
  return postRequest(`workOrder/save-asset`, values)
}

export async function saveService(values) {
  return postRequest(`workOrder/save-service`, values)
}

export function remove(values) {
  return postRequest(`workOrder/delete`, values)
}

export function createWorkorders(values, startDate, endDate) {
  const params = {
    values: {
      contractID: getcontractIdNumber(),
      orderNumbers: values,
      startDate,
      endDate,
    },
  }
  return postRequest(`workOrder/create-workorders`, params)
}

export function createWorkordersV2(values, startDate, endDate, includeMissedPms) {
  const params = {
    values: {
      contractID: getcontractIdNumber(),
      orderNumbers: values,
      startDate,
      endDate,
      includeMissedPms,
    },
  }
  return postRequest(`workOrder/create-workordersv2`, params)
}

export function savePdf(workOrderID, file) {
  const params = {
    values: {
      workOrderID,
      file,
    },
  }
  return postRequest(`workOrder/save-pdf`, params)
}

export async function create() {
  const ContractID = getcontractIdNumber()
  return getRequest(`workOrder/create/${ContractID}`)
}

export async function recall(workOrderID, orderNumber) {
  return getRequest(`workOrder/recall/${workOrderID}/${orderNumber || '%20'}`)
}
export async function generalCostView(workOrderID) {
  return getRequest(`workOrder/get-general-contract-cost-view2/${workOrderID}`)
}

export async function hardDelete(workOrderID) {
  return postRequest('workOrder/hard-delete', { values: { deleteID: workOrderID } })
}
